import { Button, TableCell, TableRow, Typography } from "@mui/material";

import type { SupplierNetworkConnection } from "../../../types";

interface Props {
  connection: SupplierNetworkConnection;
  onRemove: (supplierShipperId: number) => void;
  loading: boolean;
}

export function SupplierRow(props: Props) {
  const { connection, onRemove, loading } = props;
  const handleRemove = () => {
    if (
      // eslint-disable-next-line no-alert
      window.confirm(
        `Are you sure you want to remove ${connection.supplier.user.first_name} ${connection.supplier.user.last_name} from your supplier network?`,
      )
    ) {
      onRemove(connection.supplier.id);
    }
  };

  return (
    <TableRow>
      <TableCell>
        <Typography variant="body1">
          {connection.supplier.user.first_name}{" "}
          {connection.supplier.user.last_name}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {connection.supplier.user.email}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body1">
          {connection.supplier.company.name}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2">
          {new Date(connection.created_at).toLocaleDateString()}
        </Typography>
      </TableCell>
      <TableCell>
        <Button
          variant="outlined"
          size="small"
          disabled={loading}
          onClick={handleRemove}
          color="error"
        >
          Remove
        </Button>
      </TableCell>
    </TableRow>
  );
}
